// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__l1stj","left":"InfoRow_left__zINQu"};